import routerOptions0 from "/opt/node_app/app/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.0_@types+node@22.15.29_db0@0.3.2_eslint@9.17.0_jiti@2.5.1__io_nrczy2uqshfnpogj5ab3ha7xeu/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}